import React from 'react'
import { scaleLinear, scaleBand } from 'd3-scale'
import { axisLeft, axisBottom } from 'd3-axis'

import { svgHeight, findMax } from '../utils'

import AxisRenderer from './AxisRenderer'
import styled from 'styled-components'
import { createScrollContainer } from './ChartComponents'
import { pure } from 'recompose'

const VChart = ({
  margin,
  colorScale,
  contentWidth,
  valueKeys,
  data,
  unitMap,
  setSelected,
  maxValue,
  topHeight,
}) => {
  // const countUnits = R.compose(
  //   arry => arry.length,
  //   R.uniq,
  //   R.map(({ unitId }) => unitId)
  // )
  const height = svgHeight(topHeight, margin) - 20

  // const count = countUnits(data)

  // const width = count*120
  const width = Math.max(120, valueKeys.length * 25) * data.length

  const unitScale = scaleBand()
    .rangeRound([0, width])
    .paddingInner(0)
    .domain(data.map(d => d.unitId))

  const keyScale = scaleBand()
    .padding(0.15)
    .domain(valueKeys)
    .rangeRound([0, unitScale.bandwidth()])

  const valScale = scaleLinear()
    .rangeRound([height, 0])
    .domain([0, findMax(maxValue, valueKeys, data)])

  const xAxis = axisLeft(valScale).ticks(null, 's')
  const yAxis = axisBottom(unitScale).tickFormat(unitId => unitMap[unitId] || unitId)

  const Bar = styled.rect`
    cursor: pointer;
  `

  const rects = data.map((row, idx) => (
    <g key={row.unitId} transform={`translate(${unitScale(row.unitId)},0)`}>
      {idx % 2 === 0 && (
        <rect
          x="0"
          y="0"
          style={{ fill: '#e3e3e3' }}
          width={unitScale.bandwidth()}
          height={height}
        />
      )}

      {valueKeys
        .filter(key => {
          const res = height - valScale(row[key]) > 0

          return res
        })
        .map(key => (
          <Bar
            key={`${row.unitId}-${key}`}
            x={keyScale(key)}
            y={valScale(row[key])}
            width={keyScale.bandwidth()}
            height={height - valScale(row[key])}
            fill={colorScale(key)}
            onClick={() => setSelected(row.unitId, key)}
          >
            <title>{`${key}:${row[key]}`}</title>
          </Bar>
        ))}
      <g transform={`rotate(-90,${unitScale.bandwidth() / 2},${height / 2}) `}>
        <text
          x={unitScale.bandwidth() / 2}
          y={height / 2}
          style={{
            fontWeight: 'bold',
            fontSize: 22,
            fill: 'rgba(0,0,0,.6)',
            alignmentBaseline: 'middle',
            textAnchor: 'middle',
          }}
        >
          {row.unitId}
        </text>
      </g>
    </g>
  ))

  const Container = styled(createScrollContainer(contentWidth, topHeight))`
    margin-top: 10px;
    margin-bottom: 10px;
  `

  return (
    <Container>
      <svg width={width + margin.left + margin.right} height={topHeight - 20}>
        <g transform={`translate(${margin.left},${margin.top})`}>
          <AxisRenderer axis={xAxis} />
          <AxisRenderer dy={height} axis={yAxis} />
          {rects}
        </g>
      </svg>
    </Container>
  )
}

export default pure(VChart)
